module.exports = __webpack_public_path__ + "img/ultimate.947c2f9.png";